<template>
  <van-row v-html="this.list.content"> </van-row>
</template>
<script>
export default {
  data() {
    return {
      list: "",
    };
  },

  mounted() {
    this.getPrivacy();
  },
  methods: {
    getPrivacy() {
      this.axios({
        method: "post",
        url: "api/page/findByLabel",
        data: {
          label: "系统文章",
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.list = res.data.data.filter((e) => {
            return e.id == 4;
          });
          this.list = this.list[0];
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/p {
  text-align: left;
  font-size: 16px;
}
/deep/.ql-align-center {
  margin-top: 0.625rem;
  text-align: center;
}
/deep/ u {
  word-break: break-all;
}
.van-row {
  box-sizing: border-box;
  padding: 0.3125rem;
}
</style>


// WEBPACK FOOTER //
// src/components/privacy.vue